import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import request from 'utils/request'
import _find from 'lodash/find'

import BasePureComponent from 'utils/BasePureComponent'

import Select from 'components/Select'
import DriversList from './DriversList'
import SelectedClient from './SelectedClient'

import { CLIENTS_URL, VEHICLE_DRIVERS } from 'constants'

import { addClient, deleteClient } from './actions'


import './style.scss'


export class DriversForm extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      clients: []
    }

    this._bind(
      '_addClient', '_deleteClient',
      '_submitDrivers', '_fetchClients',
      '_renderClient', '_convertToOption'
    )
  }

  _convertToOption(client) {
    const label = `${client.user.first_name} ${client.user.last_name} - ${client.user.email}`
    return {
      value: client.id,
      label
    }
  }

  _fetchClients(label) {
    return request(`${CLIENTS_URL}?q=${label}`)
      .then(({clients}) => {
        const options = clients.map(this._convertToOption)

        this.setState({ clients })

        return { options }
      })
      .catch(console.log)
  }

  _addClient(selectedClient) {
    const id = !!selectedClient ? selectedClient.value : null
    if (!!id) {
      const client = _find(this.state.clients, { id })
      this.props.addClient(client)
    }
  }

  // nicer way to avoid `() => this.props.deleteClient(id)`
  // in code and we can prevent-default behavior of buttons
  _deleteClient(id) {
    return (evt) => {
      evt.preventDefault()
      this.props.deleteClient(id)
    }
  }

  _renderClient(client, index) {
    return (
      <SelectedClient
        key={index}
        client={client}
        onDelete={this._deleteClient(client.id)}
      />
    )
  }

  _submitDrivers() {
    // get only clients id
    const clients = this.props.clients.map((c) => c.id)
    const users = Object.values(this.props.drivers)

    // if there aren't drivers/users to be added/created call success callback to cancel process
    // since drivers aren't mandatory for vehicles
    if (!clients.length && !users.length)
      return !!this.props.onSuccess && this.props.onSuccess()

    request(VEHICLE_DRIVERS(this.props.clientId, this.props.vehicleId), {
      method: 'POST',
      body: { clients, users }
    })
    .then((res) => {
      !!this.props.onSuccess && this.props.onSuccess(res)
    })
    .catch(console.log)
  }

  render() {
    return (
      <section className="DriversForm">
        <div className="DriversForm__instructions">
          <h1>Agregar conductores</h1>
          <p>Los “conductores” serán aquellos capaces de reportar un siniestro en ésta póliza</p>
        </div>
        <div className="DriversForm__section-title">
          <strong>Puedes asignar un cliente existente como conductor</strong>
        </div>
        <div className="DriversForm__clients">
          <Select
            cache={false}
            loadingPlaceholder="Buscando..."
            loadOptions={this._fetchClients}
            noResultsText='Sin resultados'
            onChange={this._addClient}
            placeholder="Buscar Cliente"
            searchPromptText=""
            value={null}
          />
          { this.props.clients.map(this._renderClient) }
        </div>
        <div className="DriversForm__section-title">
          <strong>O crear uno nuevo</strong>
        </div>
        <div className="DriversForm__rows">
          <DriversList />
        </div>
        {this.props.renderFooter(this._submitDrivers)}
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clients: state.driversForm.get('clients').toJS(),
    drivers: state.driversForm.get('drivers').toJS()
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    addClient: (client) => dispatch(addClient(client)),
    deleteClient: (id) => dispatch(deleteClient(id)),
    dispatch
  }
}


DriversForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func,
  /*
  * this function will render any buttons needed on the footer
  * will receive `this._submitData` method-reference as prop so parent component can call
  * this method and perform drivers assignment
  * we did it like this since DriversForm is a connected-Component
  * and we can't access to DriversForm methods
  * this might have it's performance downsides but there is no other way to do DriversForm
  * 100% standalone.
  */
  renderFooter: PropTypes.func,
  clientId: PropTypes.string.isRequired,
  vehicleId: PropTypes.number.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(DriversForm)



// WEBPACK FOOTER //
// ./src/components/DriversForm/index.js